import { Button, styled, useTheme, Box } from '@mui/material';

const CustomIconButton = styled(Button)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: `${theme.spacing(3.5)} !important`,
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: `${theme.spacing(6.25)}px`,
  color: '#787878',
  textTransform: 'none',
  padding: theme.spacing(2, 3),
  borderRadius: theme.spacing(2),
  backgroundColor: 'transparent',
  border: 'none',
  boxShadow: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  '&:hover': {
    backgroundColor: 'rgba(120, 120, 120, 0.04)',
    boxShadow: 'none',
  },
  '&:focus': {
    boxShadow: 'none',
  },
}));

const IconImage = styled('img')(({ theme }) => ({
  width: theme.spacing(6.25),
  height: theme.spacing(6.25),
  flexShrink: 0,
}));

const IconButton = ({ text, icon, onClick, sx = {}, ...props }) => {
  const theme = useTheme();

  return (
    <CustomIconButton
      onClick={onClick}
      sx={{
        ...sx,
      }}
      {...props}
    >
      <IconImage src={icon} alt="" />
      <Box component="span">{text}</Box>
    </CustomIconButton>
  );
};

export default IconButton;
